<app-header></app-header>
<div class="breadcrumbs">
  <app-breadcrumbs></app-breadcrumbs>
</div>
<div id="main">
  <router-outlet />
</div>
